import { render, staticRenderFns } from "./LehrgangSelectModal.vue?vue&type=template&id=62a76e3a"
import script from "./LehrgangSelectModal.vue?vue&type=script&lang=js"
export * from "./LehrgangSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports